import { render, staticRenderFns } from "./EntitlementsLabel.vue?vue&type=template&id=34978f62"
import script from "./EntitlementsLabel.vue?vue&type=script&lang=js"
export * from "./EntitlementsLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports